/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Operacje na cookies, data storage
 * Operacje na zmiennych
 *
 * @export
 * @class DataTools
 */

export class DataTools {
	constructor() {
		this.checkCookies();
	}
	// ****************************************************************************************************
	// konwersja separatora na "."
	// ****************************************************************************************************
	convertFloatSeparator(str) {
		return str.replace(',', '.');
	}
	// ****************************************************************************************************
	// usunięcie spacji z poczatku i konca stringa
	// ****************************************************************************************************
	removeWhitespace(str) {
		return str.trim();
	}
	// ****************************************************************************************************
	// usunięcie liter ze stringa + ostatniego znaku jeśli to . lub ,
	// ****************************************************************************************************
	removeLetters(str) {
		return str.replace(/([^0-9,.])|([.,]\s*$)/g, ""); // znaki | ostatnia kropka i przecinek
	}
	// ****************************************************************************************************
	// usunięcie liter ze stringa + ostatniego znaku jeśli to . lub ,
	// ****************************************************************************************************
	removeLastZerosFromFloat(str) {
		return str;
	}
	// ****************************************************************************************************
	// usunięcie szaeregu znakow (sign) ze stringa i zastąpienie ich przez rep
	// ****************************************************************************************************
	removeMultipleSigns(str, sign, rep) {
		var regex = new RegExp('([' + sign + ']{2,})', 'g');
		return str.replace(regex, rep);
	}
	// ****************************************************************************************************
	// spr, czy string "jest" dodatnia liczbą
	// ****************************************************************************************************
	isPositiveFloat(value) {
		return (POSITIVE_FLOAT_REGEX.test(value));
	}
	// ****************************************************************************************************
	// funkcja zaogrąglająca
	// ****************************************************************************************************
	roundTo(value, accuracy) {
		if (typeof (accuracy) === 'undefined')
			accuracy = 2;
		return Math.round(value * Math.pow(10, accuracy)) / Math.pow(10, accuracy);
	}
	// ****************************************************************************************************
	// spr czy cookies sa obsługiwane
	// ****************************************************************************************************
	checkCookies(name) {
		document.cookie = 'test=test;path=/';
		if (!document.cookie) {
			document.location.href = '/message?cookieinfo';
		}
	}
	// ****************************************************************************************************
	// pobranie ciasteczka
	// ****************************************************************************************************
	getCookie(name) {
		let cookies = document.cookie.split(';');
		for (let i = 0; i < cookies.length; i++) {
			let c = cookies[i].split('=');
			let c_name = c[0];
			if (c_name.charAt(0) == ' ')
				c_name = c_name.substr(1);
			if (c_name == name)
				return c[1];
		}
		return false;
	}
	// ****************************************************************************************************
	// zapisanie ciasteczka
	// ****************************************************************************************************
	setCookie(name, val, expDni) {
		if (expDni === undefined) {
			var expires = '';
		}
		else {
			var dateExp = new Date();
			dateExp.setTime(dateExp.getTime() + (expDni * 24 * 60 * 60 * 1000));
			var expires = '; expires=' + dateExp.toGMTString();
		}
		document.cookie = name + '=' + val + expires + ';path=/;domain=' + COOKIE_DOMAIN;
	}
	// ****************************************************************************************************
	// formatowanie nazwy obrazka
	// ****************************************************************************************************
	removeDiactricMarks(str) {
		if (LANGUAGE == 'pl') {
			str = str.replace(/ą/g, 'a');
			str = str.replace(/Ą/g, 'A');
			str = str.replace(/ć/g, 'c');
			str = str.replace(/Ć/g, 'C');
			str = str.replace(/ę/g, 'e');
			str = str.replace(/Ę/g, 'E');
			str = str.replace(/ł/g, 'l');
			str = str.replace(/Ł/g, 'L');
			str = str.replace(/ń/g, 'n');
			str = str.replace(/Ń/g, 'N');
			str = str.replace(/ó/g, 'o');
			str = str.replace(/Ó/g, 'O');
			str = str.replace(/ś/g, 's');
			str = str.replace(/Ś/g, 'S');
			str = str.replace(/ż|ź/g, 'z');
			str = str.replace(/Ż|Ź/g, 'Z');
		}
		else if (LANGUAGE == 'de') {
			str = str.replace(/ä/g, 'a');
			str = str.replace(/Ä/g, 'A');
			str = str.replace(/ö/g, 'o');
			str = str.replace(/Ö/g, 'O');
			str = str.replace(/ü/g, 'u');
			str = str.replace(/Ü/g, 'U');
			str = str.replace(/ß/g, 'ss');
		}
		else if (LANGUAGE == 'cs') {
			str = str.replace(/á/g, 'a');
			str = str.replace(/é/g, 'e');
			str = str.replace(/í/g, 'i');
			str = str.replace(/ó/g, 'o');
			str = str.replace(/ú/g, 'u');
			str = str.replace(/ý/g, 'y');
			str = str.replace(/ě/g, 'e');
			str = str.replace(/š/g, 's');
			str = str.replace(/č/g, 'c');
			str = str.replace(/ř/g, 'r');
			str = str.replace(/ž/g, 'z');
			str = str.replace(/ď/g, 'd');
			str = str.replace(/ť/g, 't');
			str = str.replace(/ň/g, 'n');
			str = str.replace(/Á/g, 'A');
			str = str.replace(/É/g, 'E');
			str = str.replace(/Í/g, 'I');
			str = str.replace(/Ó/g, 'O');
			str = str.replace(/Ú/g, 'U');
			str = str.replace(/Ý/g, 'Y');
			str = str.replace(/Č/g, 'C');
			str = str.replace(/Š/g, 'S');
			str = str.replace(/Ř/g, 'R');
			str = str.replace(/Š/g, 'S');
			str = str.replace(/Ě/g, 'E');
			str = str.replace(/Ž/g, 'Z');
			str = str.replace(/ů/g, 'u');
			str = str.replace(/ľ/g, 'l');
			str = str.replace(/Ľ/g, 'L');
		}
		else if (LANGUAGE == 'sl') {
			str = str.replace(/Č/g, 'C');
			str = str.replace(/č/g, 'c');
			str = str.replace(/Š/g, 'S');
			str = str.replace(/š/g, 's');
			str = str.replace(/Ž/g, 'Z');
			str = str.replace(/ž/g, 'z');
		}
		return str;
	}
	// ****************************************************************************************************
	// formatowanie nazwy obrazka
	// ****************************************************************************************************
	formatImageName(str, ext) {
		var that = this;
		return that.removeDiactricMarks(str.toLowerCase()).replace(/[^a-z0-9]/g, '-').replace(/([-]{2,})/g, '-').replace(/[-]{1,}$/, '') + ext;
	}
	// ****************************************************************************************************
	// formatowanie ceny
	// ****************************************************************************************************
	formatPrice(float) {
		var formatter;
		var price;

		if ( LANGUAGE == 'en' || LANGUAGE == 'sl' ) {
			formatter = new Intl.NumberFormat('en-US', {
				style: 'decimal',
				minimumFractionDigits: 2
			});
			price = formatter.format(float);
		} else {
			// ru = separator tyś -> spacja, sep. dz. -> ,
			formatter = new Intl.NumberFormat('ru', {
				style: 'decimal',
				minimumFractionDigits: 2
			});
			price = formatter.format(float);
		}

		return price;
	}
	// ****************************************************************************************************
	// decodowanie znaków specjalnych na entities
	// ****************************************************************************************************
	encodeHtmlEntities(str) {
		var that = this;
		return str.replace(/[\u00A0-\u9999<>\&"]/gim, function (i) {
			return '&#' + i.charCodeAt(0) + ';';
		});
	}
	// ****************************************************************************************************
	// przekształcanie stringa na obj JSON
	// ****************************************************************************************************
	stringToJson(str, test=false) {
		if ( test ) {
			console.log(str.replace(/(\r\n|\n|\r|\t)/gm, ""));
		}
		return JSON.parse( str.replace(/(\r\n|\n|\r)/gm, "") ); // wyczyszczenie ze znkaów konca linii
	}

	// ****************************************************************************************************
	// liczba losowa z zakresu min - max (z min i max włącznie )
	// ****************************************************************************************************
	randomIntFromInterval(min, max) {
		return Math.floor(Math.random() * (max - min + 1) + min);
	}
}